export function isValidMerchantId(merchantId, merchantList = []) {
    return merchantList.some((merchant) => merchant.merchantId === merchantId);
}